import { useThemeContext } from '../../lib/ThemeContext';
import styles from './ThemeToggle.module.css';

/**
 * Switches between the light and dark palettes in `styles/tokens.css`.
 *
 * The label and `aria-label` name the theme this will switch *to*, not the one
 * currently active — a control is named for what it does, and "Dark mode" on a
 * button that is already showing dark reads as a broken toggle.
 */
export function ThemeToggle(): React.JSX.Element {
  const { theme, toggle } = useThemeContext();
  const next = theme === 'light' ? 'dark' : 'light';

  return (
    <button
      type="button"
      className={styles.toggle}
      onClick={toggle}
      aria-label={`Switch to ${next} theme`}
    >
      {theme === 'light' ? <MoonIcon /> : <SunIcon />}
      <span className={styles.label}>{next === 'dark' ? 'Dark' : 'Light'}</span>
    </button>
  );
}

function MoonIcon(): React.JSX.Element {
  return (
    <svg
      className={styles.icon}
      width="15"
      height="15"
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M14 9.5A6.2 6.2 0 0 1 6.5 2a6.5 6.5 0 1 0 7.5 7.5Z"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function SunIcon(): React.JSX.Element {
  return (
    <svg
      className={styles.icon}
      width="15"
      height="15"
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
    >
      <circle cx="8" cy="8" r="3.1" stroke="currentColor" strokeWidth="1.4" />
      <path
        d="M8 1.3v1.6M8 13.1v1.6M14.7 8h-1.6M2.9 8H1.3M12.74 3.26l-1.13 1.13M4.39 11.61l-1.13 1.13M12.74 12.74l-1.13-1.13M4.39 4.39 3.26 3.26"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </svg>
  );
}
